import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { OnboardingService, OnBoardingStepRedirects } from "@m19-board/services/onboarding.service";
import { map } from "rxjs";

export const onboardingGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const onboardingService = inject(OnboardingService);
  const router = inject(Router);
  return onboardingService.currentStep$.pipe(
    map((step) => {
      const redirect = OnBoardingStepRedirects[step];
      if (redirect === true) return true;
      return router.createUrlTree([OnBoardingStepRedirects[step]]);
    }),
  );
};
